import { useEffect, useState } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  const texts = [
    "O reflexo de um bom trabalho em esquadrias de alumínio, vidros temperados, guarda-corpo e espelhos",
    "Trabalhamos também com coberturas, fachada pele de vidro, breeze e painel ripado"
  ];

  useEffect(() => {
    setIsVisible(true);
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Alterna o texto a cada 4 segundos
    const textInterval = setInterval(() => {
      setCurrentTextIndex((prev) => (prev + 1) % texts.length);
    }, 4000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(textInterval);
    };
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/2a15a8e107f797aae727e97c2d795150.jpg"
            alt="Hero Background"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className={`relative z-10 container mx-auto px-4 md:px-6 w-full transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="text-center max-w-5xl mx-auto">
          {/* Decorative line above title */}
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-16 bg-[#C0C0C0]"></div>
            <div className="h-px w-16 bg-[#C0C0C0] ml-2"></div>
          </div>

          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 md:mb-8 leading-tight tracking-tight">
            <span className="inline-block bg-gradient-to-r from-white via-[#C0C0C0] to-white bg-clip-text text-transparent drop-shadow-2xl">
              Alumi Innova
            </span>
          </h1>

          <div className="relative inline-block mb-8 md:mb-10 min-h-[120px] md:min-h-[140px] flex items-center">
            <div className="absolute inset-0 bg-[#C0C0C0]/20 blur-xl rounded-lg"></div>
            <p 
              key={currentTextIndex}
              className="relative text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white font-semibold mb-0 max-w-4xl mx-auto leading-relaxed px-6 py-4 bg-black/20 backdrop-blur-sm rounded-lg border border-white/20 animate-fade-in"
            >
              {texts[currentTextIndex]}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 px-4">
            <button
              onClick={() => window.open('https://api.whatsapp.com/send?phone=551974098245', '_blank')}
              className="relative w-full sm:w-auto bg-gradient-to-r from-[#D4AF37] via-[#F9D77E] to-[#D4AF37] hover:from-[#F9D77E] hover:via-[#D4AF37] hover:to-[#F9D77E] text-[#010E31] font-bold px-10 md:px-12 py-5 md:py-5 rounded-xl transition-all duration-300 inline-flex items-center justify-center space-x-2 whitespace-nowrap shadow-2xl hover:shadow-[#D4AF37]/80 hover:scale-110 animate-pulse hover:animate-none border-2 border-[#D4AF37] group overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
              <span className="text-lg md:text-xl relative z-10">Solicitar Orçamento</span>
              <i className="ri-arrow-right-line text-2xl relative z-10 group-hover:translate-x-1 transition-transform"></i>
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white/40 font-semibold px-8 md:px-10 py-4 md:py-4 rounded-lg transition-all duration-300 inline-flex items-center justify-center space-x-2 whitespace-nowrap hover:scale-105"
            >
              <span className="text-base md:text-lg">Conheça Nossos Serviços</span>
              <i className="ri-arrow-down-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
